/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_DEVOPS_REPORT_PRECONDITION } from './viewDevToolsPermissionKey.constants.tsx';
import type { PreconditionResult } from './PreconditionResult.types.tsx';

export const devOpsReportPreconditionResource: RouteResource<PreconditionResult> =
	createResource<PreconditionResult>({
		type: RESOURCE_TYPE_DEVOPS_REPORT_PRECONDITION,
		getKey: ({ query }) => query.projectKey,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-devops-report-precondition", jiraSpaEntry: "async-resource-devops-report-precondition" */ './getData.tsx'
			),
		maxAge: 60 * 1000,
	});

export const useDevOpsReportPreconditionResource =
	(): UseResourceHookResponse<PreconditionResult> =>
		useResource<PreconditionResult>(devOpsReportPreconditionResource);
